// ============================================================
// [2.13.0] Pont d'adresse. Les serveurs Siverix envoient vers
// `<central>/admin/#/sso?audience=…` (console sous /admin/, HashRouter).
// Le serveur de comptes sert sa console À LA RACINE (BrowserRouter) : cette
// adresse y tomberait sur une page inconnue. On la réécrit en `/sso?…` avant
// le premier rendu. Seul un chemin interne de l'application est accepté.
// ============================================================

export function bridgedPath(base: string, pathname: string, hash: string): string | null {
  if (base !== '/') return null;
  if (!/^\/admin\/?$/.test(pathname)) return null;
  if (!hash.startsWith('#/') || hash.startsWith('#//')) return null;
  return hash.slice(1);
}
